import { ROUTE_BUILD_ACTION_PLAN } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './build-action-plan.page';

export const routeBuildActionPlan: RouteObject = {
  path: ROUTE_BUILD_ACTION_PLAN,
  Component: Page,
  loader: setTitleFromLoader('Action Plan Builder'),
};
